import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';
import { unlockAudio } from './lib/sound';

// First user interaction unlocks Web Audio so the OTP overlay can play
// the alert tone on subsequent OTP arrivals.
const unlock = () => {
  unlockAudio();
  window.removeEventListener('click', unlock);
  window.removeEventListener('keydown', unlock);
};
window.addEventListener('click', unlock);
window.addEventListener('keydown', unlock);

// FR-WEB-012 — top-level ErrorBoundary catches any uncaught render error
// from the tree below and renders a friendly fallback instead of a white
// screen. Outer position (outside StrictMode) so a throw during the
// StrictMode double-render is still caught.
createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <StrictMode>
      <App />
    </StrictMode>
  </ErrorBoundary>,
);
